import { isValidTimezone } from "@/lib/utils/timezone";
import { z } from "zod";
import { holidaysSchema, openingHoursSchema, simpleHolidaysSchema, specialHoursSchema } from "./hours-schema";

export const locationInputSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(3, "Name must be at least 3 characters").max(255, "Name too long"),
  slug: z.string()
    .min(3, "Slug must be at least 3 characters")
    .max(255, "Slug too long")
    .regex(/^[a-z0-9-]+$/, { message: 'Slug can only contain lowercase letters, numbers, and hyphens' }),
  description: z.string().min(10, "Description must be at least 10 characters").max(1000, "Description too long").nullable().optional(),
  address: z.string().min(5, "Address must be at least 5 characters"),
  address2: z.string().optional(),
  city: z.string().min(2, "City must be at least 2 characters"),
  region: z.string().optional(),
  country: z.string().min(2, "Country is required").default("CA"),
  postal: z.string().min(3, "Postal code must be at least 3 characters"),
  phone: z.string().optional(),
  email: z.string().email("Invalid email address").optional(),
  website: z.string().url("Invalid website URL").optional(),
  latitude: z.coerce.number().optional(),
  longitude: z.coerce.number().optional(),
  isActive: z.boolean().default(true),
  isFeatured: z.boolean().default(false),
  isSponsored: z.boolean().default(false),
  isPromoted: z.boolean().default(false),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  keywords: z.array(z.string()).default([]),
  timezone: z.string().refine(isValidTimezone, {
    message: "Invalid timezone identifier"
  }).default("America/Edmonton"),
  openingHours: openingHoursSchema.optional(),
  specialHours: specialHoursSchema.optional(),
  holidays: z.union([holidaysSchema, simpleHolidaysSchema]).optional(),
  amenities: z.array(z.string()).default([]),
});

export type LocationInputItem = z.infer<typeof locationInputSchema>;

// Response type for location actions
export interface LocationActionResponse {
  success: boolean
  message?: string
  location?: any
  error?: any
}

export const locationStaffSchema = z.object({
  locationId: z.string().min(1, "Location ID is required"),
  userId: z.string().min(1, "User ID is required"),
  role: z.enum(["ADMIN", "INSTALLER"])
});

export type LocationStaffData = z.infer<typeof locationStaffSchema>;
